import { Component, OnInit, ViewChild } from '@angular/core';
import { BlockUI, UserEncounterCount, UserService } from "@harlowe/core";
import { IUser, UserInsert, UserUpdate } from "@harlowe/core"
import { TableEditCompleteEvent, TableModule, Table} from 'primeng/table';
import { ProcedureSelectorComponent } from '@harlowe/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { NgModule } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmPopupModule } from 'primeng/confirmpopup';                  
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxChangeEvent, CheckboxModule } from 'primeng/checkbox';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { Store } from '@ngxs/store';
import { UserState } from '@harlowe/core';
import { MessagesModule } from 'primeng/messages';
import { Message } from 'primeng/api';
import { EncounterState } from '../../../state/encounters/encounter-state';
import { TealCompEncounterHeader } from '../../../models/encounter';
import { Observable, take } from 'rxjs';
import { UserInterface } from '../../../state/ui/ui-actions';

@Component({
  selector: 'app-users',
  standalone: true,
  imports: [TableModule, ProcedureSelectorComponent, FormsModule, InputTextModule, ButtonModule, CommonModule, ToastModule, ConfirmPopupModule, DropdownModule, CheckboxModule, IconFieldModule, InputIconModule, MessagesModule],
  templateUrl: './users.component.html',
  styleUrl: './users.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class UsersComponent implements OnInit {
  @ViewChild('dt1') table: Table | undefined;

  users_list$: Observable<IUser[]> = this._store.select(UserState.users_list);
  user_list: IUser[] = [];

  logged_in_user$ = this._store.select(UserState.currentUser);
  current_user_id: number = -1;

  new_users: IUser[] = [];
  insertable_users = new Set();
  max_new_users_reached: boolean = false;

  messages: Message[] = [];

  encounterCounts: UserEncounterCount[] = [];

  encounterCountsLoaded: boolean = false;

  prev_field_data: string = '';

  sortings = [{ display: "Id", sort_field: "id"}, { display: "First Name", sort_field: "firstName"}, { display: "Last Name", sort_field: "lastName" }, { display: "Active", sort_field: "active" }]
  sort_request: boolean = false; 

  constructor (
    private _users: UserService, private confirmationService: ConfirmationService, private _store: Store
  )
  {}
  
  async ngOnInit() {
    this.logged_in_user$.subscribe
    (
      async user =>
      {
        if (user != null && user.id != null)
        {
          this.current_user_id = user.id;
        }
      }
    );

    this.users_list$.pipe(take(1)).subscribe
    (
      async users =>
      {
        this.user_list = JSON.parse(JSON.stringify(users)); // Perform deepcopy
        this.encounterCounts = await this._users.getUserEncounterCounts();
        this.encounterCountsLoaded = true;
      }
    )
    
    // );
    this.messages = [{ severity: 'info', detail: "Can insert a maximum of 10 users at once."}]
    // console.log(this.users_list);
  }

  getEncounterCount(id: number)
  {
    var encounter_count: number = 0;
      encounter_count = this.encounterCounts.find(u => u.userId == id)?.count ?? 0;

    return encounter_count;
  }
  
  onGlobalFilter(table: Table, event: Event)
  {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  tableChanged() { this.sort_request = true; }

  refreshTable()
  {
    this.sort_request = true;
    this.user_list = [...this.user_list];
  }

  prevRowState(event: any) { this.prev_field_data = event.data; }
  
  addBlankUser()
  {
    if (this.new_users.length < 10)
    {
      this.new_users.push({} as IUser);
      this.max_new_users_reached = false;
    }
    else
    {
      this.max_new_users_reached = true;
    }
  } 

  checkNewUser(rowIndex: number)
  {
    var new_user: IUser = this.new_users[rowIndex];
    if (this.validateField(new_user.externalId, new_user.id) && new_user.externalId && new_user.firstName && new_user.lastName && new_user.active)
    {
      this.insertable_users.add(new_user);
    }
    else if (this.insertable_users.has(new_user))
    {
      this.insertable_users.delete(new_user);
    }
  }

  upperCaseName(name: string) { return name.charAt(0).toUpperCase() + name.slice(1); }

  validateField(externalId: string, id: number) // Checks if externalId already exists
  {
    if (this.user_list.find(user => user.externalId == externalId && user.id != id)) { return false; }
    return true;
  }

  async userEdited(event: TableEditCompleteEvent) 
  { 
    if (this.sort_request)
    {
      this.sort_request = false;
      return;
    }

    
    if (event.index !== undefined && event.index !== null)
    {
      var user_index: number = this.user_list.findIndex(user => user.id == this.table?.value[event.index as number]["id"]);
      var current_user: IUser = this.user_list[user_index];
     
      if (this.validateField(current_user.externalId, current_user.id) && event.data && this.prev_field_data != event.data)
      {

        console.log(current_user.externalId, current_user.id);
        console.log("Updated User Index: " + user_index.toString);
        var updated_user = new UserUpdate(current_user.id);

        if (event.field == "externalId")
        {
          updated_user.externalId = event.data;
        }
        else if (event.field == "firstName")
        {
          updated_user.firstName = this.upperCaseName(event.data);
        } 
        else if (event.field == "lastName")
        {
          updated_user.lastName = this.upperCaseName(event.data);
        }
 
        this._store.dispatch(new BlockUI.BlockUI());
        this.user_list[user_index] = await this._users.updateUser(current_user.id, updated_user);
        this.refreshTable();
        this._store.dispatch(new BlockUI.UnBlockUI());

      } 
      
    }

  }

  
  async insertNewUsers() {
      var new_user_indeces = new Set<number>();
      for (var i = 0; i < this.new_users.length; i++)
      {
        var current_user = this.new_users[i];

        if (current_user.externalId && current_user.firstName && current_user.lastName && current_user.active) 
        {
          current_user.firstName = this.upperCaseName(current_user.firstName);
          current_user.lastName = this.upperCaseName(current_user.lastName);
          var new_user = new UserInsert(current_user);
          this.user_list.push(await this._users.insertUser(new_user));
          new_user_indeces.add(i);
          this.refreshTable();
        }
      }

      var tmp_new_users: IUser[] = [];
      for (var i = 0; i < this.new_users.length; i++) 
      {
        if (new_user_indeces.has(i)) { continue; }
        tmp_new_users.push(this.new_users[i]);
      }
      this.new_users = tmp_new_users;
      this.insertable_users.clear();
  } 

  confirmDelete(event: Event, id: number, rowIndex: number) 
  {
    if (id != -1) 
    {
      this.confirmationService.confirm({
          target: event.target as EventTarget,
          message: 'Are you sure you want to proceed?',
          icon: 'pi pi-exclamation-triangle',
          acceptButtonStyleClass: 'p-button-danger p-button-sm',
          accept: async () => {
            var user_index = this.user_list.findIndex(user => user.id == id);
            await this._users.deleteUser(id);
            this.user_list.splice(user_index, 1);
            this.refreshTable();
          } 
      });
    } else {
      var user = this.new_users[rowIndex];
      this.new_users.splice(rowIndex, 1);
      if (this.insertable_users.has(user)) { this.insertable_users.delete(user); }
      if (this.max_new_users_reached) { this.max_new_users_reached = false };
    }
  }

  async statusChanged(event: CheckboxChangeEvent, id: number)
  {
    if (id)
    {
      var user_index: number = this.user_list.findIndex(user => user.id == id);
      
      var updated_user = new UserUpdate(id);
      updated_user.active = event.checked; 
      this.user_list[user_index] = await this._users.updateUser(id, updated_user);
    } 
  }
}
